<template>
  <section id="resume" class="section">
    <div class="container">
      <!-- Heading -->
      <p class="text-center mb-2" data-aos="fade-up" data-aos-once="true">
        <span class="bg-primary text-dark px-2">Resume</span>
      </p>
      <h2 class="text-10 fw-600 text-center mb-5" data-aos="fade-up" data-aos-once="true">
        A summary of My Resume
      </h2>
      <!-- Heading end-->

      <div class="row g-5 mt-5">
        <!-- My Education -->
        <div class="col-lg-6" data-aos="fade-right" data-aos-once="true">
          <h2 class="text-7 fw-600 mb-4 pb-2">My Education</h2>
          <div class="border-start border-2 border-primary ps-3">
            <h3 class="text-5">Design Classics</h3>
            <p class="mb-2">UX/UI 2010 - 2011</p>
            <p class="text-muted">I completed the design course.</p>
            <hr class="my-4" />
            <h3 class="text-5">Bachelor in Computer Application</h3>
            <p class="mb-2">VNSGU University / 2006 - 2019</p>
            <p class="text-muted">I completed BCA In VNSGU University.</p>
          </div>
        </div>
        <!-- My Experience -->
        <div class="col-lg-6" data-aos="fade-left" data-aos-once="true">
          <h2 class="text-7 fw-600 mb-4 pb-2">My Experience</h2>
          <div class="border-start border-2 border-primary ps-3">
            <h3 class="text-5">UI/UX Designer| Full Time</h3>
            <p class="mb-2"> November 2021 - Present</p>
            <p class="text-muted">I have been working as a freelancer for the last year and providing my best service to clients. Auto layout, Component, Typography, Color Palette, Icons</p>
            <hr class="my-4" />
            <h3 class="text-5">UI/UX Designer | Weapplinse Technology </h3>
            <p class="mb-2">February 2016 - November 2020</p>
            <p class="text-muted">Understand project requirements, Mobile app design, Website UI/UX design, Wireframe and Prototype design, User research, User testing.
            </p>
          </div>
        </div>
      </div>

      <!-- My Skills -->
      <h2 class="text-7 fw-600 mb-4 pb-2 mt-5" data-aos="fade-up" data-aos-once="true">
        My Skills
      </h2>
      <div class="row gx-5">
        <div class="col-md-6" data-aos="fade-up" data-aos-once="true">
          <p class="fw-500 text-start mb-2">
            Adobe XD <span class="float-end">89%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 89%" aria-valuenow="89" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Adobe Illustrator<span class="float-end">85%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 95%" aria-valuenow="95" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Adobe Photoshop<span class="float-end">90%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Adobe InDesign<span class="float-end">70%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Miro <span class="float-end">60%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>         
        </div>
        <div class="col-md-6" data-aos="fade-up" data-aos-once="true">
          <p class="fw-500 text-start mb-2">
            Figma<span class="float-end">92%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 92%" aria-valuenow="92" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            InVision <span class="float-end">90%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Zeplin <span class="float-end">75%</span>
          </p>
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
          <p class="fw-500 text-start mb-2">
            Balsamiq <span class="float-end">85%</span>
          </p>
          
          <div class="progress progress-sm mb-4">
            <div class="progress-bar" role="progressbar" style="width: 85%" aria-valuenow="85" aria-valuemin="0"
              aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MyResume",
};
</script>

<style>

</style>